import Icon from '@mdi/react'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { ICompliance } from '@/types/tasksApprovals'

import TaskItem from '../../item/task'
import OptionalRequiredTasks from './components/optionalRequired'

interface IProps {
    tasks: ICompliance[]
    icon: string
    title: string
    isDirect?: boolean
    isLastItem?: boolean
}

const TasksList = ({ tasks, icon, title, isDirect = false, isLastItem = false }: IProps) => {
    const textColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')
    const arrowColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')

    const otherTasks = tasks.filter((task) => task.system_id !== 'MY_LEARNING_RO')
    const myLearningROTasks = {
        optional: tasks.filter((task) => task.system_id === 'MY_LEARNING_RO' && task?.metadata?.type === 'OPTIONAL'),
        required: tasks.filter((task) => task.system_id === 'MY_LEARNING_RO' && task?.metadata?.type === 'REQUIRED'),
    }

    const requiredTasks = myLearningROTasks.required.length > 0 && (
        <OptionalRequiredTasks
            tasks={myLearningROTasks.required}
            title={`${myLearningROTasks.required.length} required trainings`}
            icon={icon}
            textColor={textColor}
            arrowColor={arrowColor}
        />
    )

    const optionalTasks = myLearningROTasks.optional.length > 0 && (
        <OptionalRequiredTasks
            tasks={myLearningROTasks.optional}
            title={`${myLearningROTasks.optional.length} optional trainings`}
            icon={icon}
            textColor={textColor}
            arrowColor={arrowColor}
        />
    )

    if (isDirect) {
        return (
            <Box pr={['16px', '24px']} pb={isLastItem ? '' : '16px'}>
                <AccordionRoot multiple border="0" margin="0" p="0">
                    <AccordionItem border="0" p="0" value={title}>
                        <AccordionItemTrigger p="0" _hover={{ backgroundColor: 'transparent' }}>
                            <Flex alignItems="center">
                                <Icon path={icon} size="16px" color="var(--chakra-colors-gray-500)" />
                                <Text pl="8px" fontSize="14px" fontWeight="bold" lineHeight="20px" color={textColor}>
                                    {title}
                                </Text>
                            </Flex>
                            {/* <AccordionIcon color={arrowColor} ml="12px" /> */}
                        </AccordionItemTrigger>
                        <AccordionItemContent p="0">
                            {otherTasks.map((task) => (
                                <TaskItem item={task} key={task.id} />
                            ))}

                            {requiredTasks}
                            {optionalTasks}
                        </AccordionItemContent>
                    </AccordionItem>
                </AccordionRoot>
            </Box>
        )
    }

    return (
        <Box pr={['16px', '24px']} py="16px">
            <Flex alignItems="center">
                <Icon path={icon} size="16px" color="var(--chakra-colors-gray-500)" />
                <Text pl="8px" fontSize="14px" fontWeight="bold" lineHeight="20px" color={textColor}>
                    {title}
                </Text>
            </Flex>
            {otherTasks.map((task) => (
                <TaskItem item={task} key={task.id} />
            ))}
            {requiredTasks}
            {optionalTasks}
        </Box>
    )
}

export default TasksList
